import { Environment } from '@gea/digital-ui-lib';
import { EnvironmentModel } from './model/environment.model';

export const environment: EnvironmentModel = {
  production: false,
  name: Environment.DEV,
  oAuth: {
    clientId: 'd03ef182-fce9-4c85-8c40-a3718b38988a',
    authority: 'https://login.portal.tst.gea.com/geaidtst.onmicrosoft.com/b2c_1_signin_signup/',
    authorityDomain: 'login.portal.tst.gea.com',
    postLogoutRedirectUri: 'https://insightpartner.blu-red-care.apps.dev.gea.com',
    redirectUri: 'https://insightpartner.blu-red-care.apps.dev.gea.com',
    passwordResetAuthority: 'https://mock-password-reset-authority.com',
    consentApplicationKey: 'hrt_insightpartner-bluredcare',
  },
  baseURL: 'https://api.apps.tst.gea.com/',
  translationBlob: 'https://content.apps.tst.gea.com/strg-container-i18n/',
  subscriptionKey: '',
  hrt: {
    baseURL: 'https://webapp-dev.hrt-digital-products.apps.dev.gea.com/frontend/v1/',
    subscriptionKey: '8929385dc1224974adf8cb732451023e',
  },
  portal: {
    baseURL: 'https://portal.tst.gea.com/',
  },
  bluShopUrl: 'https://blushop.tst.gea.com/shop_dev/app?forcerestart=true'
};
